// @ts-check
import { defineStore } from "pinia";

export const useBinningsStore = defineStore("binings", {
  state: () => ({
    items: [],
    sellers: {},
    pagination: null,
    loading: false,
  }),
});
